import { motion } from "framer-motion";

const DARK_BG = "#172033";
const CARD_BG = "#1E2A3B";
const ORANGE = "#E8470A";

export function DestinationHighlights({ title, description, highlights }) {
  return (
    <section style={{ backgroundColor: DARK_BG, padding: "96px 0" }}>
      <div style={{ maxWidth: "1140px", margin: "0 auto", padding: "0 24px" }}>

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true, margin: "-80px" }}
          style={{ marginBottom: "56px", maxWidth: "640px" }}
        >
          <span style={{
            display: "block",
            color: ORANGE,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.28em",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}>
            Por qué visitarlo
          </span>
          <h2 style={{
            fontSize: "clamp(28px, 3.5vw, 40px)",
            fontWeight: 800,
            color: "#ffffff",
            lineHeight: 1.15,
            margin: "0 0 16px",
          }}>
            {title}
          </h2>
          <p style={{
            fontSize: "16px",
            lineHeight: 1.7,
            color: "rgba(255,255,255,0.55)",
            margin: 0,
          }}>
            {description}
          </p>
        </motion.div>

        {/* Cards grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "16px",
        }}>
          {highlights.map((h, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }}
              viewport={{ once: true, margin: "-50px" }}
              style={{
                backgroundColor: CARD_BG,
                borderRadius: "16px",
                padding: "28px",
              }}
            >
              {/* Number badge */}
              <div style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "rgba(232,71,10,0.15)",
                marginBottom: "20px",
              }}>
                <span style={{
                  color: ORANGE,
                  fontSize: "12px",
                  fontWeight: 800,
                }}>
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <h3 style={{
                fontSize: "17px",
                fontWeight: 700,
                color: "#ffffff",
                margin: "0 0 10px",
                lineHeight: 1.3,
              }}>
                {h.title}
              </h3>

              <p style={{
                fontSize: "14px",
                lineHeight: 1.7,
                color: "rgba(255,255,255,0.58)",
                margin: 0,
              }}>
                {h.description}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
